<template>
    <v-dialog v-model="show" width="400" persistent no-click-animation>
        <div class="ExportReportEditor">
            <!--Dialog header-->
            <div class="dialog-header">
                <div>
                    {{ $f.tc('exportReport') }}
                    <!--{{ campaign ? $utils.limitStringLength(campaign.title, 20) : '' }}-->
                </div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <v-form v-model="formValid" @submit="submit" ref="form" class="dialog-content">
                <!--From datetime-->
                <div class="label">{{ $f.tc('from') }}</div>
                <div class="d-flex align-center">
                    <div style="width: 184px; margin-right: 8px">
                        <DateTimeInput
                            v-model="fromDate"
                            type="date"
                            :min="'1900-01-01'"
                            :color="'#0052CC'"
                            :width="184"
                        ></DateTimeInput>
                    </div>
                    <div style="width: 184px">
                        <DateTimeInput
                            v-model="fromTime"
                            type="time"
                            :color="'#0052CC'"
                            :width="184"
                        ></DateTimeInput>
                    </div>
                </div>
                <!--To datetime-->
                <div class="label">{{ $f.tc('to') }}</div>
                <div class="d-flex align-center">
                    <div style="width: 184px; margin-right: 8px">
                        <DateTimeInput
                            v-model="toDate"
                            type="date"
                            :min="fromDate || '1900-01-01'"
                            :max="today"
                            :color="'#0052CC'"
                            :width="184"
                        ></DateTimeInput>
                    </div>
                    <div style="width: 184px">
                        <DateTimeInput
                            v-model="toTime"
                            type="time"
                            :color="'#0052CC'"
                            :width="184"
                        ></DateTimeInput>
                    </div>
                </div>
                <!--Email-->
                <div class="label">{{ $f.tc('email') }}</div>
                <v-text-field
                    v-model="model.email"
                    :rules="formRules.email"
                    class="input-custom"
                    disabled
                ></v-text-field>
                <div class="d-flex align-center">
                    <v-checkbox
                        v-model="includeNotAttempted"
                        :label="$f.tc('includeNotAttemptedCustomer')"
                        color="#0052CC"
                        :hide-details="true"
                    ></v-checkbox>
                </div>

            </v-form>
            <!--Dialog footer-->
            <div class="dialog-footer">
                <div class="btn-custom" @click="submit">{{ $f.tc('export') }}</div>
                <div class="btn-outline" @click="close">{{ $f.tc('cancel') }}</div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import FormMixin from '@/modules/fptai/mixins/FormMixin'
import moment from "moment";
import CampaignService from "@/services/campaign.service";
import i18n from "@/plugins/i18n";
import DateTimeInput from "@/components/DateTimeInput";

export default {
    name: 'ExportReportEditor',
    mixins: [FormMixin],
    components: {DateTimeInput},
    props: {
        onSaved: Function
    },
    data() {
        let today = this.$moment().format('YYYY-MM-DD')
        return {
            fromDate: '',
            fromTime: '',
            toDate: '',
            toTime: '',
            today: today,
            formValid: false,
            show: false,
            model: {
                permission: this.$const.campaign.permission.VIEWER,
                email: this.$store.state.user.profile.email
            },
            campaign: null,
            dataTable: [],
            permissionList: [
                this.$const.campaign.permission.VIEWER,
                this.$const.campaign.permission.OUTBOUND_CALLER
            ],
            showConfirmOverlay: false,
            userToDelete: false,
            timeRangeExport: 30,
            includeNotAttempted: false,
        }
    },
    computed: {
        headers() {
            return []
        }
    },
    methods: {
        open(campaign, filter) {
            this.show = true
            this.campaign = campaign
            this.model.email = this.$store.state.user.profile.email
            this.fromDate = filter.fromDate
            this.fromTime = filter.fromTime.substr(0, 5)
            this.toDate = filter.toDate
            this.toTime = filter.toTime.substr(0, 5)
        },
        close() {
            this.show = false
            this.$refs.form.reset()
        },
        check_month(fromDate, toDate) {
            this.timeRangeExport = this.campaign['time_range_export_output'] ? this.campaign['time_range_export_output'] : 30
            fromDate = moment(this.fromDate)
            toDate = moment(this.toDate)
            return toDate.diff(fromDate, "day") < this.timeRangeExport
        },
        submit(event) {
            if (event) {
                event.preventDefault()
            }
            if (this.formValid) {
                if (this.check_month()) {
                    this.$appService.showLoading()
                    let from = {
                        date: this.fromDate,
                        time: `${this.fromTime}:00`
                    }
                    let to = {
                        date: this.toDate,
                        time: `${this.toTime}:59`
                    }
                    CampaignService.sendCampaignReport(this.$route.params['campaignId'], from, to, this.includeNotAttempted).then(
                        () => {
                            this.$appService.hideLoading()
                            this.$appService.toastSuccess(this.$f.tc('actionSuccessful', i18n))
                            this.close()
                        }
                    )
                } else {
                    this.$appService.toastError('Period must be less than ' + this.timeRangeExport + ' days')
                }
            } else {
                this.$refs.form.validate()
            }
        },
        toggleNotAttempted() {
            this.includeNotAttempted = !this.includeNotAttempted
        }
    },
    watch: {}
}
</script>

<style scoped lang="scss">
.ExportReportEditor {
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .btn-custom {
        margin-right: 8px;
    }

    .label {
        margin-top: 12px;
        font-family: "open sans semi";
        font-size: 13px;

        &:first-child {
            margin-top: 0 !important;
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;
            position: relative;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-input__slot {
        margin-bottom: 0 !important;
    }

    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }

    label {
        font-family: "open sans", serif !important;
        font-size: 14px !important;
        color: #000 !important;
    }
}
</style>
